import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorType } from 'enums';

import './ErrorMessage.scss';

interface IErrorMessageProps {
    type: ErrorType;
    message?: string;
    dataCy?: string;
}


export const ErrorMessage: FunctionComponent<IErrorMessageProps> = function ({ type, message, dataCy }) {
    const { t, i18n } = useTranslation();

    const errorTypeKeys = {
        [ErrorType.Generic]: 'errors.generic',
    }

    const errorKey = errorTypeKeys[type] || errorTypeKeys[ErrorType.Generic];

    return (
        <p className="errorMessage" data-cy={dataCy}>
            {t(errorKey)} <br />
            {message}
        </p>
    );
}



